module.exports = __webpack_public_path__ + "media/images/companies/tss-15e15a3b074beacbd2cd59a6ba9eaf14.png";